import { useState } from "react";
import "./KnowMorePage.css";

import dividendImg from "../assets/dividend-tax.png";
import capitalGainImg from "../assets/capital-gains.png";

function Accordion({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="accordion">
      <button className="accordion-header" onClick={() => setOpen(!open)}>
        <span>{title}</span>
        <span className="arrow">{open ? "−" : "+"}</span>
      </button>

      {open && <div className="accordion-body">{children}</div>}
    </div>
  );
}

function KnowMorePage() {
  return (
    <div className="knowmore">

      <h1>Investment Insights</h1>

      {/* 1. SIP */}
      <Accordion title="SIP – Can Mutual Funds help you reach ₹1 Crore?">
        <p>
          A question I get asked all the time: <strong>
          “Can investing in mutual funds really make my portfolio reach ₹1 crore?”
          </strong>
        </p>

        <p>
          The answer lies in following a <strong>SYSTEM</strong> built on:
        </p>

        <ul>
          <li>✔ SIPs</li>
          <li>✔ Top-ups</li>
          <li>✔ Bold lump sum investments during market opportunities</li>
        </ul>

        <p>
          Decades of data show that even a ₹5,000 monthly SIP over 20 years can
          potentially help reach the ₹1 crore milestone.
        </p>

        <h4>Real Combinations:</h4>
        <table>
          <thead>
            <tr>
              <th>Combination</th>
              <th>Future Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>10K SIP × 15 yrs + 6L Lump sum</td>
              <td>₹1.04 Cr</td>
            </tr>
            <tr>
              <td>15K SIP × 20 yrs + 8L Lump sum</td>
              <td>₹2.63 Cr</td>
            </tr>
            <tr>
              <td>25K SIP × 25 yrs (5% step-up)</td>
              <td>₹7.15 Cr</td>
            </tr>
          </tbody>
        </table>

        <p className="contact">
          Want to create a tailored KROPS CAPITAL plan?  
          📞 +91 7400 34 1134 | ✉ sampark@kropsindia.com
        </p>
      </Accordion>

      {/* 2. Home Loan vs SIP */}
      <Accordion title="Home Loans vs SIPs – A mindset shift">
        <p>
          Salaried professionals pay EMIs for 15–20 years without fail — rain,
          recession, or rate hikes.
        </p>

        <p>
          But SIPs are often stopped at the first market dip — even though SIPs
          are designed to build long-term wealth.
        </p>

        <p>
          <strong>Flip the mindset:</strong>  
          Treat your SIP like an EMI — fixed, non-negotiable, and goal-oriented.
        </p>

        <p>
          Discipline matters more than returns. Stay invested.
        </p>
      </Accordion>

      {/* 3. Dividend Tax */}
      <Accordion title="Tax on Dividend Income">
        <p>
          Finance Act 2020 shifted dividend taxation from companies to investors.
          Dividend income is now taxable as per individual slab rates.
        </p>

        <img
          src={dividendImg}
          alt="Tax on Dividend"
          className="accordion-image"
        />

        <p className="contact">
          Questions? Write to us at ✉ sampark@kropsindia.com
        </p>
      </Accordion>

      {/* 4. Capital Gains */}
      <Accordion title="Capital Gains on Shares">
        <p>
          Capital gains are classified as <strong>STCG</strong> or <strong>LTCG</strong>
            depending on holding period.
        </p>

        <p>
          Understanding loss set-offs and exemptions is crucial for tax-efficient
          investing.
        </p>

        <img
          src={capitalGainImg}
          alt="Capital Gains on Shares"
          className="accordion-image"
        />

        <p className="contact">
          Need clarity? Reach out via this website or ✉ sampark@kropsindia.com
        </p>
      </Accordion>

    </div>
  );
}

export default KnowMorePage;
